const tr = {
  'Language Key': 'tr',
  'cui-org-info': 'Kuruluş bilgisi',
  'cui-sign-on-info': 'bilgi üzerine yap',
  'cui-user-info': 'Kullanıcı bilgisi',
  'cui-preferences': 'Tercihler',
  'cui-review': 'gözden geçirmek',
  'cui-org': 'organizasyon',
  'cui-company-division': 'Şirket / Bölüm',
  'cui-org-address': 'Kuruluş Adresi',
  'cui-user-address': 'Kullanıcı Adresi',
  'cui-country': 'ülke',
  'cui-city': 'Kent',
  'cui-state': 'Eyalet / İl',
  'cui-postal': 'Posta kodu',
  'cui-user-id': 'Kullanıcı adı',
  'cui-password': 'Parola',
  'cui-password-re': 'Şifreyi yeniden gir',
  'cui-challenge-question': 'Yarışma sorusu',
  'cui-challenge-answer': 'Mücadelesi cevap',
  'cui-favorite-pet-q': 'En sevdiğiniz evcil hayvanın adı ne?',
  'cui-mother-q': 'Annenizin kızlık soyadı nedir?',
  'cui-best-friend-q': 'En iyi arkadaşın kim?',
  'cui-first-name': 'İsim',
  'cui-last-name': 'Soyadı',
  'cui-email': 'E-posta',
  'cui-email-re': 'E-mail adresinizi yeniden girin',
  'cui-telephone': 'Telefon numarası',
  'cui-timezone': 'Saat dilimi',
  'cui-submit': 'GÖNDER',
  'cui-next': 'SONRAKİ ADIM',
  'cui-previous': 'ÖNCEKİ',
  'cui-create-security-admin-account': 'Güvenlik yönetici hesabı oluşturun',
  'cui-skip-for-now': 'ŞİMDİLİK GEÇ',
  'icon-library': 'Simge Kütüphanesi',
  'cui-new-TLO': 'Yeni Üst Seviye Organizasyonu',
  'cui-new-TLO-description': 'Yeni bir Covisint Örgütü gibi Covisint Değişimi katılmak istiyorsanız bu yöntemi seçin',
  'cui-new-division': 'Yeni Bölümü',
  'cui-new-division-description-start': 'Eğer olmak istiyorsanız bu yöntemi seçin',
  'cui-new-division-description-end': 'Mevcut bir Covisint Örgütü içinde yeni bir bölünme.',
  'cui-security-administrator': 'Güvenlik Yöneticisi',
  'cui-new-user': 'Yeni kullanıcı',
  'cui-new-user-description': 'Eğer örgüt abone veya emin değilseniz kuruluşunuzun kayıtlı olduğu takdirde bir uygulamaya varolan Covisint Üye Firma arayan erişimin bir çalışan ise bu yöntemi seçin.',
  'cui-sign-up': 'Kaydol',
  'cui-address': 'Adres',
  'cui-organization-name': 'Şirket / Bölüm',
  'cui-supplier-code': 'tedarikçi Kodu',
  'cui-address-1': 'Adres 1',
  'cui-address-2': 'Adres 2',
  'cui-user-information': 'Kullanıcı bilgisi',
  'cui-organization-information': 'Organizasyon Bilgileri',
  'cui-sign-in-information': 'Bilgi Oturum',
  'cui-package-selection': 'Paket Seçimi',
  'cui-welcome-popover': 'Eğer bir kayıt yöntemi seçmek sonrasında Güvenlik Yöneticisi sorumlulukları ayrıntılı olarak anlatılacaktır. Ancak, Organiziation farklı bir üyesi Güvenlik Yöneticisi olarak kayıt yaptırmasına izin için kaydınızı iptal seçebilir.',
  'create-account': 'Hesabını oluştur',
  'cui-agree-covisint': 'Ben Covisint kabul',
  'terms-of-service': 'Kullanım Şartları',
  'cui-and': 've',
  'privacy-policy': 'Gizlilik Politikası',
  'cui-tos-agree': 'Devam etmek için Hizmet Şartlarını kabul etmelisiniz.',
  'cui-user-profile': 'Kullanıcı profili',
  'cui-my-profile': 'Benim profilim',
  'cui-login': 'Oturum aç',
  'cui-supplier-content': 'tasarım dokümanlarının gelip bir kere bu güncelleme. Bu çeviri google doc içindedir. Ipsum. Diğer şey. Tedarikçi kodu önemli bilgiler. Kaplumbağaları severim.',
  'cui-all-organizations': 'Tüm kuruluşlar:',
  'cui-application-select-info': 'Her zaman ilk kez giriş yaptıktan sonra seçimler yapabilirsiniz.',
  'cui-all-applications': 'Bütün uygulamalar',
  'cui-page-not-found': 'Sayfa bulunamadı',
  'cui-page-not-found-content': 'Eğer silinen veya hiç olabilirdi Aradığınız sayfa var olmuştur.',
  'cui-home': 'EV',
  'cui-access-denied': 'Erişim reddedildi',
  'cui-access-denied-content': 'Bu sayfayı görüntüleme yetkiniz yok.',
  'cui-registration-status': 'Kayıt Durumu',
  'cui-pending-status': 'Bekleme durumu',
  'cui-pending-status-content': 'Kaydınız durumu hala beklemede. Kısa süre içinde daha fazla ayrıntı içeren bir e-posta alacaksınız.',
  'cui-thank-you': 'teşekkür ederim',
  'cui-request-submitted': 'İsteği Gönderildi',
  'cui-success': 'başarı',
  'cui-success-content': 'Kişisel Covisint kaydı başarıyla gönderildi. Kısa süre içinde daha fazla ayrıntı içeren bir e-posta alacaksınız.',
  'cui-check-your': 'Çekinizi',
  'cui-registration-status-lower': 'Kayıt Durumu',
  'cui-application-selection': 'Uygulama Seçimi',
  'cui-applications': 'Uygulamalar',
  'cui-profile-settings': 'Profil ayarları',
  'cui-name': 'isim',
  'cui-update': 'Güncelleştirme',
  'cui-updated': 'Güncellenmiş',
  'cui-error-try-again': 'Hata! Tekrar deneyin?',
  'cui-back': 'Geri',
  'cui-selections': 'Seçimler',
  'cui-add-org': 'Kuruluş ekle',
  'cui-remove-org': 'Organizasyon kaldır',
  'cui-select-org': 'Kuruluş seçin',
  'cui-more-information': 'Daha fazla bilgi',
  'cui-inv-user-popover-info': 'Güvenlik nedenlerinden dolayı, senin davetinin gönderildiği e-mail ile kaydetmeniz gerekir. Bu kayıt işlemi tamamlandığında kullanıcı ayarları içinde düzenlenebilir.',
  'cui-org-profile': 'Organizasyon Profili',
  'cui-info': 'Bilgi',
  'cui-admins': 'Yöneticiler',
  'lowercase-not-allowed': 'Herhangi küçük harf yok',
  'uppercase-not-allowed': 'herhangi büyük harf harf yok',
  'numbers-not-allowed': 'herhangi bir sayı yok',
  'special-not-allowed': '(: * +! Ex) özel simgeleri yok',
  'chars-not-allowed': 'aşağıdaki karakterlerden birini içermemeli: {{disallowedChars}}',
  'words-not-allowed': 'aşağıdaki kelimelerden birini içermemeli: {{disallowedWords}}',
  'password-length': '{{min}}-{{max}} arası karaktere sahip',
  'password-rules': "aşağıdakilerden {{requiredNumberOfCharClasses}}'üne sahip:",
  'password-lowercase': 'en az 1 küçük harf harf',
  'password-uppercase': 'en az 1 büyük harf',
  'password-number': 'en az 1 numara',
  'password-special': 'en az 1 özel sembol (örn: *! +)',
  'passwords-must': 'Şifreler gerekir:',
  'welcome-title': 'Aşağıdakilerden biri için Kayıt',
  'cui-application-name': 'Uygulama Adı',
  'cui-application-tos': 'İnceleme Koşulları',
  'cui-application-tos-agreement': 'Şartlar ve Koşullar Anlaşması',
  'cui-package-tos': 'Seçilen paketleri koşullarını kabul etmedi.',
  'cui-view-tos': 'Görünüm Koşulları',
  'password-mismatch': 'Parolalar eşleşmeli',
  'cui-back-to-review': 'Yoruma Dön',
  'email-mismatch': 'E-postalar aynı olmalıdır',
  'no-applications-selected': 'Seçilen herhangi bir uygulama yok. geri başvuru seçime gitmek için buraya tıklayın.',
  'cui-all-fields-required': 'tüm alanlar zorunludur',
  'cui-complete-registration': 'aşağıda Kaydınızı tamamlayın',
  'cui-registered': 'Kayıtlı',
  'cui-open': 'Açık',
  'cui-close': 'Kapat',
  'cui-street-address': 'Açık adres',
  'cui-zip': 'Zip',
  'cui-language': 'Dil',
  'cui-phone-main': 'Ana',
  'cui-phone-office': 'Ofis',
  'cui-phone-fax': 'Telefon / Faks',
  'cui-phone-mobile': 'seyyar',
  'cui-save': 'Kayıt etmek',
  'cui-cancel': 'İptal etmek',
  'cui-edit': 'Düzenle',
  'cui-phone': 'Telefon',
  'search-by-app-name': 'Uygulama adına göre ara',
  'new-request': 'Yeni istek',
  'select-applications': 'seç Uygulamalar',
  'browse-applications': 'Göz Uygulamaları',
  'go': 'Gitmek',
  'filter-list': 'Filtre listesi',
  'filter': 'filtre',
  'owning-org': 'sahip olmak Org',
  'my-applications': 'Benim Uygulamaları',
  'app-summary': 'Uygulama Özeti',
  'granted': 'verilen',
  'bundled-applications': 'Birlikte Uygulamalar',
  'application-details': 'Uygulama Detayları',
  'my-claims': 'Benim İddialar',
  'related-applications': 'İlgili Uygulamalar',
  'review-request': 'İnceleme İsteği',
  'back-to-search': 'Geri Arama',
  'requested-items': 'Talep edilen Öğeler',
  'request-reason': 'talep Nedeni',
  'reason-im-requesting': 'Sebep ben talep ediyorum',
  'you-must-enter-a-reason': 'Bu uygulamayı istemek için bir sebep girmelisiniz',
  'cui-org-no-applications': 'Kuruluşunuz herhangi bir uygulama yoktur gibi görünüyor. Her zaman giriş yaptıktan sonra tekrar deneyebilirsiniz.',
  'cui-filter-org-name': 'Organizasyon ada göre filtre',
  'cui-address-example': 'Apt, Suite, Bldg. (isteğe bağlı)',
  'cui-filter-app-name': 'Uygulama adına göre filtrele',
  'cui-search-user-name': 'Ada göre ara kullanıcılar',
  'page': 'Sayfa',
  'cui-num-results-page': 'sayfa başına sonuç',
  'submit-request': 'İstek gönderin',
  'categories': 'Kategoriler',
  'cui-answer': 'Cevap',
  'cui-enter-password': 'Parolanı Gir',
  'cui-enter-new-password': 'Yeni şifreyi girin',
  'cui-re-enter-new-password': 'yeni şifreyi tekrar giriniz',
  'granted-to-my-org': 'kuruluşum Verilen',
  'collected-items-for-request': 'İsteği Toplanan öğeler',
  'cui-invalid-password': 'Geçersiz şifre. Lütfen tekrar deneyin.',
  'cui-faq': 'SSS',
  'cui-frequently-asked-questions': 'sık sorulan Sorular',
  'cui-admin-tools': 'Yönetici araçları',
  'cui-this-field-is-required': 'Bu alan gereklidir.',
  'cui-this-field-needs-to-be-longer': 'Bu alan daha uzun olması gerekir.',
  'cui-you-need-to-agree-to-toc': "Sen devam etmeden önce Hizmet Şartları'nı kabul etmek gerekir.",
  'cui-this-is-not-valid-email': 'Bu, geçerli bir e-posta değil.',
  'cui-my-app-requests': 'Benim Uygulama İstekleri',
  'cui-no-claims': 'Bu uygulama için hiçbir hak talebi var.',
  'cui-no-details': 'Hiçbir detayı mevcut.',
  'request': 'İstek',
  'all': 'Herşey',
  'no-selected-apps': 'Sen herhangi bir uygulama seçmediniz.',
  'basic-info': 'Temel Bilgiler',
  'cui-error-username-exists': 'Kullanıcı kimliği zaten var! Lütfen başka birini seçiniz.',
  'password-reset': 'Parola sıfırlama',
  'current-password': 'Şimdiki Şifre',
  'timezone-and-language': 'Saat dilimi ve Dil',
  'challenge-questions': 'meydan Sorular',
  'security-question-repeated': 'Bu cevap zaten kullanıldı.',
  'cui-by-date-added': 'Ekleme Tarihi',
  'cui-alphabetically': 'Alfabetik',
  'active': 'Aktif',
  'pending': 'kadar',
  'suspended': 'Askıya alındı',
  'title': 'Başlık',
  'id': 'İD',
  'url': 'URL',
  'privacy-terms': 'Gizlilik ve Şartlar',
  'help': 'yardım et',
  'cui-learn-more-start': 'Daha fazla bilgi edin',
  'cui-learn-more-end': 'Bu bilgileri sormak neden',
  'cui-org-hierarchy': 'Organizasyon Hiyerarşi',
  'directory': 'rehber',
  'userID': 'Kullanıcı adı',
  'status': 'durum',
  'locked': 'Kilitli',
  'rejected': 'Reddedilen',
  'removed': 'Kaldırılan',
  'sort': 'Çeşit',
  'refine': 'arıtmak',
  'or': 'Veya',
  'organizations': 'Organizasyonlar',
  'roles': 'Roller',
  'organization-applications': 'Organizasyon Uygulamaları',
  'unactivated': 'Devre dışı',
  'log-out': 'Çıkış Yap',
  'welcome': 'Hoşgeldiniz',
  'privacy': 'Gizlilik',
  'terms': 'şartlar',
  'user': 'kullanıcı',
  'top-level-orgs': 'Üst Düzey Kuruluşları',
  'invite-user': 'Kullanıcı Davet',
  'invite-division': 'Bölümü Davet',
  'username': 'Kullanıcı adı',
  'move': 'hareket',
  'no-bundled-or-related': 'Hiçbir paketlenmiş veya uygulama ile ilgili.',
  'cui-continue': 'Devam et',
  'cui-no-org-divisions': 'Hiçbir örgüt bölünmeler',
  'inactive': 'etkisiz',
  'deny': 'Reddetmek',
  'approve': 'onaylamak',
  'pending-request': 'Beklemede İsteği',
  'review-approvals': 'İnceleme Onaylar',
  'cui-package-no-claims': 'Bu paket hiç iddialar içeriyor',
  'claims': 'Hasar',
  'package-name': 'Paket ismi',
  'submit-approvals': 'Onaylar Gönder',
  'view-details': 'Detayları göster',
  'request-date': 'İstek Tarihi',
  'registration-decision': 'Kayıt Karar',
  'requested': 'Talep edilen',
  'getting-user-info': 'Kullanıcı bilgilerini alınıyor ...',
  'approvals-submitted': 'Onaylar Ekleyen',
  'rejection-submitted': 'Reddetme Ekleyen',
  'approval-summary': 'Onay Özeti',
  'approved-items': 'Onaylı Öğeler',
  'rejected-items': 'Reddedilen Öğeler',
  'registration-request-approved': 'Onaylanan kayıt isteği',
  'registration-request-rejected': 'Reddedilen kayıt isteği',
  'no-items-rejected': 'Öğe yok reddedilen',
  'no-items-approved': 'Öğe yok onaylanmış',
  'registration-request': 'Kayıt Talebi',
  'custom-api-loading': 'Uygulamayı başlatılıyor ...',
  'new-grant': 'Grant App',
  'search-by-package-name': 'paket adına göre arama',
  'search': 'Arama',
  'administartor-?': 'Yönetici?',
  'submit-grant-update': 'hibe Güncelleme gönder',
  'review-user-pending-approval': 'İnceleme Kullanıcı Onay Bekliyor',
  'view-request-for': 'için Görünümü İsteğiniz',
  'job-title': 'İş ismi',
  'query': 'Sorgu',
  'suspend-app': 'App Askıya',
  'new-grants': 'Yeni Hibeler',
  'update-grant-settings': 'Güncelleme Grant Ayarları',
  'assign-new-grant-to': 'Yeni hibe atama',
  'division': 'Bölünme',
  'redirecting-to-sso': 'Kimlik bilgilerinizi isteme',
  'included-applications': 'Dahil Uygulamalar',
  'selected-sub-packages': 'Seçilmiş Alt Paketleri',
  'specify-password': 'şifresi belirleyin',
  'suspend': 'askıya almak',
  'reset-password': 'Şifreyi yenile',
  'confirm-password-reset': 'Bu kullanıcının parolasını sıfırlamak istediğinizden emin misiniz?',
  'yes': 'Evet',
  'within': 'içinde',
  'search-within': 'Içinde ara',
  'in-your-org': 'senin org içinde',
  'people': 'İnsanlar',
  'revoke-package': 'Paketi iptal et',
  'cui-by-username': 'Kullanıcı adı',
  'cui-by-status': 'durum',
  'cool-got-it': 'Serin, anladım',
  'organization-directory': 'Organizasyon Dizini',
  'org-nav-invite-links': 'Organizasyon Navigasyon ve Davet Linkler',
  'org-dir-filters': 'Organizasyon Dizin Filtreler',
  'org-dir-list': 'Organizasyon Dizin Listesi',
  'apps': 'Uygulamalar',
  'apps-upper': 'UYGULAMALAR',
  'history-upper': 'TARİHÇE',
  'profile-upper': 'PROFİL',
  'roles-upper': 'ROLLER',
  'your-app-request-in-review': 'Başvurunuz isteğiniz gönderildi',
  'error-generic': 'Bu sayfadaki verileri yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.',
  'cui-application-administrator': 'Şu anda, bir kullanıcı belirli bir uygulama için yönetim hakları verilmeden önce atanmalıdır uygulama yöneticisi rolünü yoktur. Bu tek seferlik bir ayardır.',
  'cui-assign-confirm': 'şimdi bu rol atamak ister misiniz?',
  'cui-suspend-warning': 'Bu uygulamaya erişmek mümkün olmayacaktır',
  'cui-suspend-confirm': 'Şimdi askıya almak istediğinizden emin misiniz?',
  'cui-notify-user': 'Kullanıcıyı bildir',
  'cui-users': 'Kullanıcılar',
  'cui-no': 'Yok hayır',
  'cui-remove': 'Kaldırılan',
  'cui-org-abbrev': 'Org',
  'cui-userProfile-user-error': 'kullanıcı verileri alınırken bir hata oluştu. Lütfen tekrar deneyin.',
  'cui-userProfile-security-error': 'güvenlik sorusu verileri alınırken bir hata oluştu. Lütfen tekrar deneyin.',
  'cui-userProfile-password-error': 'parola ilkesi verileri alınırken bir hata oluştu. Lütfen tekrar deneyin.',
  'cui-suspend-success': 'Bu uygulama şimdi seçilen kullanıcıdan asılır',
  'cui-unlock': 'Kilidini aç',
  'cui-unlock-password-confirm': 'Eğer bu kullanıcının şifresini kilidini istiyorum emin misiniz?',
  'cui-error-unlocking-password': 'Maalesef bu kullanıcının şifresini açma bir hata oluştu.',
  'cui-error-person-request': 'Bu kullanıcı için kayıt isteği veriler alınamıyor.',
  'cui-error-email-exists': 'E-posta adresi zaten alınmış',
  'cui-password-history-rule': 'önceki {{numberOfPasswords}} şifreleri herhangi eşleşmiyor',
  'cui-password-policy': 'Şifre politikası',
  'cui-security-admin': 'Güvenlik Yöneticiler',
  'cui-button-loading-text': 'Yükleniyor...',
  'cui-username-taken': 'Kullanıcı adı alınmış',
  'cui-no-applications': 'Şu anda hiç uygulamalara sahip',
  'cui-mask-answers': '/ Maskesini güvenlik cevapları Maske',
  'cui-pwd-reset-success': 'Şifre Başarı Reset!',
  'cui-last-login': 'Son giriş',
  'cui-need-different-app': 'farklı bir uygulama Need',
  'cui-go-back-to': 'Geri dönmek',
  'cui-tos-applications': 'Seçilen uygulamalar için Şartlar ve Koşulları kabul edin',
  'cui-selected-apps': 'Seçilmiş Uygulamalar',
  'cui-authentication-policy': 'Kimlik Politikası',
  'cui-selected': 'seçilmiş',
  'cui-tac': 'Şartlar ve koşullar',
  'cui-accept': 'Kabul etmek',
  'cui-tac-agree': 'Sen Şartlar ve devam etmek için Koşullarını kabul etmelisiniz.',
  'cui-printer-friendly-tac': 'Yazıcı dostu Şartlar ve Koşullar',
  'cui-my-history': 'Benim tarihim',
  'cui-status-history': 'Durumum Geçmişi',
  'cui-app-history': 'Uygulama Geçmişi',
  'cui-password-change-log': 'Şifre değiştirme günlüğü',
  'cui-date': 'tarih',
  'cui-event-type': 'Etkinlik tipi',
  'cui-action-by': 'Eylem tarafından yapılır',
  'cui-notes': 'notlar',
  'cui-try-again': 'Lütfen tekrar deneyin.',
  'cui-password-change-log-error': 'Bir hata alınırken Şifre değişikliği günlüğü yoktu.',
  'cui-userstatus-history-error': 'Bir hata alınırken Kullanıcı durum geçmişi yoktu.',
  'cui-claims-error': 'Claims alınırken bir hata oluştu.',
  'cui-org-app-suspend-success': 'Bu uygulama artık seçilen kuruluşlar, tüm kullanıcılar ve tüm alt kuruluşlardan askıya alınır.',
  'cui-org-app-suspend-msg1': 'aktif kullanımda Bu eylem bile tüm kullanıcılar ve alt kuruluşlarından eylemi askıya alırız.',
  'cui-org-app-suspend-msg2': 'Eğer askıya almak istediğinize emin misiniz',
  'cui-from': 'itibaren',
  'cui-application-granted-history': 'Uygulama Grant Geçmişi',
  'cui-application-requested-history': 'Uygulama İstek Geçmişi',
  'approved': 'onaylı',
  'decision': 'Karar',
  'evaluator': 'Değerlendirici',
  'action': 'Aksiyon',
  'cui-invalid-invitation': 'Davet zaten kullanılmakta veya Geçersiz olan ya',
  'cui-by-request-date': 'İstek Tarihi',
  'cui-by-decision-date': 'Karar günü',
  'cui-no-orgs-for-name': 'Belirtilen isim için hiçbir organizasyonlar. farklı bir isimle deneyin.',
  'requests': 'İstekler',
  'no-pending-apps': 'Beklemede olan uygulama istekleri var.',
  'description': 'Açıklama',
  'launch': 'Başlatmak',
  'manage-applications': 'Uygulamaları Yönet',
  'request-type': 'İstek Türü',
  'phase': 'Faz',
  'date-submitted': 'İletilen Tarih',
  'cui-pending-requests-error': 'güncellenirken / alınırken bir hata oluştu.',
  'no-requests-by-name': 'Belirtilen isim için hiçbir istekleri. farklı bir isimle deneyin.',
  'cannot-change-password': 'Şimdi şifreyi değiştirilemiyor',
  'select-claims': 'seç İddialar',
  'grant-reason': 'Grant Nedeni',
  'grants-assigned': 'Yeni Hibeler Atanan',
  'suspend-error': 'istekleri askıya bir hata oluştu.',
  'unsuspend-error': 'mek isteklerinde bir hata oluştu.',
  'approval': 'onay',
  'administrator': 'yönetici',
  'submitted': 'Gönderilen',
  'no-bundled': 'Hiçbir paket uygulamalar',
  'disallowed-password-rule': 'İzin verilmeyen kelimeler listesinde bir kelime içeremez',
  'request-approve-or-rejected': 'Bu istek ya / Onaylı Reddedildi edilir',
  'application': 'Uygulama',
  'show-all': 'Hepsini Göster ↓',
  'cui-subject': 'konu',
  'cui-es': '(Ler)',
  'cui-invite-user': 'içinde Kullanıcıyı Davet',
  'cui-invite-user-success': 'Kullanıcı davetiye isteği gönderildi',
  'cui-email-recipt': 'Alıcı e-posta girin (virgül ile ayrı çoklu)',
  'cui-invite-verbiage': 'Aşağıdakilerden biri için davet',
  'select': 'seçmek',
  'change-org': 'Değişim Org',
  'cui-invite-user-sub': 'Bir kullanıcı katılmak olarak kayıt',
  'cui-invite-user-select': 'Bir kuruluşun ara',
  'cui-send-invitation': 'Davetiye gönder',
  'invite': 'Davet et',
  'cui-invite-tlo-success': 'En yüksek seviye organizasyon davetiye isteği gönderildi',
  'cui-invite-tlo': 'Yeni Bir Organizasyon Davet',
  'cui-invite-division-success': 'Şirketiniz davetiye isteği gönderildi',
  'cui-invite-division': 'Bir Organizasyon Davet',
  'cui-tlo-sub': 'Yeni bir kuruluş olarak kayıt ol',
  'cui-division-sub': 'içinde yöneticiden olarak kayıt',
  'search-by-org-name': 'Organizasyon adına göre ara',
  'app-approval-error': 'Uygulama isteklerini onaylayan bir hata oluştu.',
  'modify-claims': 'Talepleri değiştirme',
  'unsuspend-app': 'unsuspend App',
  'remove-app': 'App Kaldır',
  'user-details': 'Kullanıcı detayları',
  'reason': 'neden',
  'required': 'gereklidir',
  'cui-unsuspend-confirm': 'Şimdi askıya alma işlemini iptal etmek istiyorum emin misiniz?',
  'unsuspend': 'unsuspend',
  'remove-confirm': 'Şimdi kaldırmak istediğiniz emin misiniz?',
  'remove': 'Kaldır',
  'my-organization': 'Benim Organizasyon',
  'request-app': 'İstek Uygulama',
  'no-apps-found': 'Uygulama bulunamadı.',
  'refine-search': 'Arama kriterlerini rafine edin.',
  'your-assign-role-success': 'Atanan Yeni Rol',
  'cui-assigned-roles': 'atanan Roller',
  'cui-available-roles': 'Mevcut Rolleri',
  'cui-browse-by-category': 'Kategoriye göre görüntüle',
  'cui-back-navigation-requests': 'Navigasyon ve İstekler',
  'cui-search-results': 'arama sonuçları',
  'cui-new-grant-search-results': 'Yeni Hibe Arama Sonuçları',
  'cui-username-close': 'Kullanıcı adı ve yakın navigasyon',
  'cui-user-no-apps': 'Kullanıcı herhangi bir uygulama var',
  'cui-no-roles-assigned': 'Bu kullanıcının atanmış rolleri vardır.',
  'status-history': 'Durum Geçmişi',
  'cui-no-status-history': 'Bu kullanıcının durum geçmişi vardır.',
  'cui-pwd-reset-msg1': 'Şifre Sıfırlama başarılı. Yeni şifre:',
  'cui-pwd-reset-msg2': 'Not: Yalnızca ilk görüyorsanız o zaman ikinci yarı şifre kullanıcılara gönderilecektir yarım şifre e-posta kayıtlı.',
  'users-upper': 'KULLANICILAR',
  'hierarchy-upper': 'HİYERARŞİSİ',
  'privileges': 'Ayrıcalıklar',
  'expand-all': 'Hepsini genişlet',
  'collapse-all': 'Tüm daraltmak',
  'no-records': 'Kayıt bulunamadı.',
  'contact-us': 'Bizimle iletişime geçin',
  'cui-error-organization-request': 'Bu kuruluş için kayıt isteği veriler alınamıyor.',
  'cui-error-organization-app-request': 'Bu organizasyon için uygulama isteği verileri alınamıyor',
  'cui-error-user-app-request': 'Bu kullanıcının uygulamaya istek verileri alınamıyor',
  'assign': 'Atamak',
  'search-by-person-name': 'kişi adına göre ara',
  'grant-history': 'Grant Geçmişi',
  'request-history': 'İstek Geçmişi',
  'social-login': 'Sosyal Girişi',
  'facebook': 'Facebook',
  'twitter': 'heyecan',
  'link': 'bağlantı',
  'unlink': 'bağlantısını kaldır',
  'invalid-url': 'Bu, geçerli bir URL değil.',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'yönetim',
  'services': 'Hizmetler',
  'n-phase': 'N - Faz Onayı',
  'edit-package': 'Düzenleme Paketi',
  'is-requestable': 'Talepedilebilir mi',
  'is-displayable': 'Görüntülenebilir mi',
  'is-grantable': 'grantable mi',
  'require': 'gerektir',
  'is-requestable-desc': 'Kullanıcı bu uygulamayı talep edebilirsiniz ise belirtiniz.',
  'is-grantable-desc': 'Bu uygulama kullanıcıya şirket yönetimi tarafından doğrudan verilebilir eğer belirtin',
  'is-displayable-desc': 'paket simgesi Benim Uygulamalar sayfada görüntülenecek gerekip gerekmediğini belirtin',
  'require-reason-desc': 'Bu paketin bu paketi istemek için bir sebep kullanıcıyı gerekirse belirtin',
  'company-admin': 'Şirket Yönetici',
  'application-admin': 'Uygulama Yöneticisi',
  'company-admin-desc': 'başka gerekli faz varsa bu varsayılan onay aşaması, o Evet olmalıdır',
  'application-admin-desc': 'istek ihtiyacı Kullanıcı uygulaması uygulama yöneticisi tarafından onaylanması mu?',
  'add-admins': 'Yöneticiler ekle',
  'cardinality-indicator': 'kardinalite Göstergesi',
  'cui-one': 'Bir',
  'cui-many': 'çok',
  'claim-values': 'İddia Değerler',
  'cui-add': 'Eklemek',
  'cui-view': 'Görünüm',
  'cui-claim': 'İddia',
  'cui-category': 'Kategori',
  'cui-service': 'Hizmet',
  'cui-delete': 'silmek',
  'federation-conn': 'Federasyon Bağlantı',
  'updated-date': 'Güncelleme tarihi',
  'target-url': 'Hedef URL',
  'remote-app-id': 'Uzaktan Uygulama Kimliği',
  'mobile-sso-url': "Mobil TOA URL'si",
  'mobile-app-id': 'Mobil Uygulama Kimliği',
  'cui-package': 'paket',
  'cui-create': 'yaratmak',
  'more-languages': 'Daha Diller',
  'duplicate-language-error': 'Yinelenen diller izin verilmez',
  'cui-nextstep': 'Sonraki',
  'create-package': 'Paketi oluştur',
  'manage-package-claims': 'Paket İddialar yönetme',
  'cardinality-indicator-error': 'Kardinalite Gösterge biri olamaz',
  'value-id-exists': 'Değer Kimliği zaten var',
  'claim-id-exists': 'İddia Kimliği zaten var',
  'cui-new': 'Yeni',
  'package-success-content': 'Paket başarıyla oluşturuldu',
  'add-claims': 'İddiaları ekle',
  'package-update-success': 'Paket başarıyla güncellendi'
}
export {
  tr
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/tr.js